/**
 * @description 救援预案管理 API 接口
 * @author Zhao Wang
 * @date 2026-03-12
 */

import config from "@/config"
import http from "@/utils/request"

export default {
	/**
	 * 救援预案 CRUD 接口
	 */
	rescuePlan: {
		url: `${config.HNYJ_URL}/api/v1/admin/plan/rescuePlan`,
		name: "救援预案接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	/**
	 * 救援预案分页查询接口
	 */
	rescuePlanPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/plan/rescuePlan/page`,
		name: "分页查询救援预案",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	/**
	 * 查询救援预案列表接口（不分页）
	 */
	rescuePlanList: {
		url: `${config.HNYJ_URL}/api/v1/admin/plan/rescuePlan/list`,
		name: "查询救援预案列表",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	/**
	 * 查询救援预案任务列表接口
	 */
	rescuePlanTaskList: {
		url: `${config.HNYJ_URL}/api/v1/admin/plan/rescuePlanTask/list`,
		name: "查询救援预案任务列表",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	}
}
